import type { Lesson } from '@typing-racer/shared';

export interface LessonRecord {
  stars: 1 | 2 | 3;
  bestWpm: number;
  bestAccuracy: number;
  attempts: number;
  lastPlayed: string;
}

const KEY = 'typing-racer.lessons';

export function loadLessonProgress(): Record<string, LessonRecord> {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '{}') as Record<string, LessonRecord>;
  } catch {
    return {};
  }
}

export function saveLessonResult(lesson: Lesson, wpm: number, accuracy: number, stars: 1 | 2 | 3): LessonRecord {
  const all = loadLessonProgress();
  const prev = all[lesson.id];
  const rec: LessonRecord = {
    stars: Math.max(prev?.stars ?? 1, stars) as 1 | 2 | 3,
    bestWpm: Math.max(prev?.bestWpm ?? 0, wpm),
    bestAccuracy: Math.max(prev?.bestAccuracy ?? 0, accuracy),
    attempts: (prev?.attempts ?? 0) + 1,
    lastPlayed: new Date().toISOString(),
  };
  all[lesson.id] = rec;
  try {
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch {
    /* ignore */
  }
  return rec;
}

/** First lesson without 2+ stars, or the last one. */
export function nextLesson(lessons: Lesson[], progress: Record<string, LessonRecord>): Lesson {
  return lessons.find((l) => (progress[l.id]?.stars ?? 0) < 2) ?? lessons[lessons.length - 1]!;
}
